import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ResponseBase } from '../models/response-base';
import { ExtractVehicles, FilterVehicle, Fuels, Species, Vehicle, vehicleCreate, vehiclesPaged } from '../models/vehicle';
import { Paged } from '../models/paged';

@Injectable({
    providedIn: 'root'
})
export class VehicleService {

    private URL = environment.GATEWAY + 'vehicles';

    constructor(
        private http: HttpClient
    ) { }

    getSpecies(): Observable<ResponseBase<Species[]>> {
        return this.http.get<ResponseBase<Species[]>>(`${this.URL}/species`);
    }

    getFuels(): Observable<ResponseBase<Fuels[]>> {
        return this.http.get<ResponseBase<Fuels[]>>(`${this.URL}/fuels`);
    }

    getAllPaged(assignorGuid: string, managerGuid: string, offset: number, limit: number,filters: FilterVehicle): Observable<ResponseBase<vehiclesPaged>> {

        let params = new HttpParams();
        params = params.append('managerGuid', managerGuid);
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());
        if (filters.fuel) params = params.append('fuel', filters.fuel.toString());
        if (filters.nickName) params = params.append('nickName', filters.nickName);
        if (filters.registrationPlate) params = params.append('registrationPlate', filters.registrationPlate);
        if (filters.model) params = params.append('model', filters.model);
        if (filters.manufacturer) params = params.append('manufacturer', filters.manufacturer);

        return this.http.get<ResponseBase<vehiclesPaged>>(`${this.URL}/assignors/${assignorGuid}`, { params });
    }

    getvehicleDetails(vehicleGuid: string, assignorGuid: string, managerGuid: string): Observable<ResponseBase<Vehicle>> {

        let params = new HttpParams();
        params = params.append('managerGuid', managerGuid);

        return this.http.get<ResponseBase<Vehicle>>(`${this.URL}/${vehicleGuid}/assignors/${assignorGuid}`, { params });
    }


    createvehicle(assignorGuid: string, managerGuid: string, vehicle: vehicleCreate): Observable<ResponseBase<any>> {
        
        let params = new HttpParams();
        params = params.append('managerGuid', managerGuid);

        return this.http.post<ResponseBase<any>>(`${this.URL}/assignors/${assignorGuid}`, vehicle, { params });
    }

    updatevehicle(vehicleGuid: string, assignorGuid: string, managerGuid: string, vehicle: Vehicle): Observable<ResponseBase<any>> {
        
        let params = new HttpParams();
        params = params.append('managerGuid', managerGuid);

        return this.http.put<ResponseBase<any>>(`${this.URL}/${vehicleGuid}/assignors/${assignorGuid}`, vehicle, { params });
    }

    enableDisablevehicle(vehicleGuid: string, assignorGuid: string, managerGuid: string, enable: boolean): Observable<ResponseBase<any>> {
        
        let headers = new HttpHeaders();
        headers = headers.append('no-loader', 'true');

        let params = new HttpParams();
        params = params.append('managerGuid', managerGuid);
        params = params.append('enable', enable.toString());

        return this.http.put<ResponseBase<any>>(`${this.URL}/${vehicleGuid}/assignors/${assignorGuid}/enable-disable`, null, { headers, params });
    }

    getSettingsLogistics(assignorGuid: string, managerGuid: string): Observable<ResponseBase<any>> {

        let params = new HttpParams();
        params = params.append('managerGuid', managerGuid);

        return this.http.get<ResponseBase<any>>(`${this.URL}/assignors/${assignorGuid}/settings`, { params });
    }
    
    updateSettingsLogistics(assignorGuid: string, managerGuid: string, receipt?: boolean, odometer?: boolean): Observable<ResponseBase<any>> {

        let headers = new HttpHeaders();
        headers = headers.append('no-loader', 'true');

        let params = new HttpParams();
        params = params.append('managerGuid', managerGuid);
        if (receipt != null) params = params.append('receipt', receipt.toString());
        if (odometer != null) params = params.append('odometer', odometer.toString());

        return this.http.put<ResponseBase<any>>(`${this.URL}/assignors/${assignorGuid}/settings`, null, { headers, params });
    }

    getExtract(assignorGuid: string, managerGuid: string, offset: number, limit: number, filterStartDate: Date, filterEndDate: Date): Observable<ResponseBase<Paged<ExtractVehicles>>> {

        let params = new HttpParams();
        params = params.append('managerGuid', managerGuid);
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());
        if (filterStartDate) params = params.append('startDate', filterStartDate.toISOString());
        if (filterEndDate) params = params.append('endDate', filterEndDate.toISOString());

        return this.http.get<ResponseBase<Paged<ExtractVehicles>>>(`${this.URL}/assignors/${assignorGuid}/extract`, { params });
    }
}